const TotalScopeTooltip = formatMessage => [
	{
		details: [formatMessage({id: 'project_portfolio_report.total_scope_tooltip'})],
	},
];

const ActualLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'project_budget.actual_revenue'}),
		description: [
			formatMessage({id: 'insights.baseline_tooltip_actual_text_1'}) +
				' ' +
				formatMessage({id: 'insights.baseline_tooltip_actual_text_2'}),
		],
	},
];

const PlanRevenueLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'insights.baseline_tooltip_plan_revenue'}),
		details: [formatMessage({id: 'project.win_chance'}), 'x', formatMessage({id: 'project_budget.baseline_revenue'})],
	},
	{
		description: formatMessage({id: 'insights.baseline_tooltip_text_revenue'}),
	},
];
const billableForecastTimeAndExpensesToCompleteLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'insights.baseline_tooltip_remaining_revenue'}),
		details: [formatMessage({id: 'project.win_chance'}), 'x', formatMessage({id: 'project_budget.baseline_revenue'})],
	},
	{
		description: formatMessage({id: 'insights.baseline_tooltip_text_revenue'}),
	},
];
const BillableTotalTimeAndExpensesAtCompletionLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'insights.baseline_tooltip_forecast_revenue'}),
		details: [formatMessage({id: 'project.win_chance'}), 'x', formatMessage({id: 'project_budget.baseline_revenue'})],
	},
	{
		description: formatMessage({id: 'insights.baseline_tooltip_text_revenue'}),
	},
];

const PlanCostLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'insights.baseline_tooltip_plan_cost'}),
		details: [formatMessage({id: 'project.win_chance'}), 'x', formatMessage({id: 'project_budget.baseline_cost'})],
	},
	{
		description: formatMessage({id: 'insights.baseline_tooltip_text_cost'}),
	},
];
const ForecastCostToCompleteLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'insights.baseline_tooltip_remaining_cost'}),
		details: [formatMessage({id: 'project.win_chance'}), 'x', formatMessage({id: 'project_budget.baseline_cost'})],
	},
	{
		description: formatMessage({id: 'insights.baseline_tooltip_text_cost'}),
	},
];
const TotalCostAtCompletionLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'insights.baseline_tooltip_forecast_cost'}),
		details: [formatMessage({id: 'project.win_chance'}), 'x', formatMessage({id: 'project_budget.baseline_cost'})],
	},
	{
		description: formatMessage({id: 'insights.baseline_tooltip_text_cost'}),
	},
];
const RecognitionProfitTooltip = formatMessage => [
	{
		title: formatMessage({id: 'project_budget.profit'}),
		details: [
			formatMessage({id: 'project_budget.recognition_amount'}),
			'-',
			formatMessage({id: 'project_budget.forecast_cost'}),
		],
	},
];
const RecognitionMarginTooltip = formatMessage => [
	{
		title: formatMessage({id: 'project_budget.margin'}),
		details: [formatMessage({id: 'project_budget.profit'}), '/', formatMessage({id: 'project_budget.recognition_amount'})],
	},
];
const GenericWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'placeholder.win_probability.project_portfolio.applied_tooltip_header'}),
		description: formatMessage({id: 'placeholder.win_probability.project_portfolio.applied_tooltip'}),
	},
];

export const ProjectPortfolioReportTooltips = {
	ActualLowerWinChanceTooltip,
	PlanRevenueLowerWinChanceTooltip,
	billableForecastTimeAndExpensesToCompleteLowerWinChanceTooltip,
	BillableTotalTimeAndExpensesAtCompletionLowerWinChanceTooltip,
	PlanCostLowerWinChanceTooltip,
	ForecastCostToCompleteLowerWinChanceTooltip,
	TotalCostAtCompletionLowerWinChanceTooltip,
	TotalScopeTooltip,
	RecognitionProfitTooltip,
	RecognitionMarginTooltip,
	GenericWinChanceTooltip,
};
